/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  flexPanel: Item<'FlexPanel'>;
  flexItem: Item<'FlexItem'>;
  bingMapNavigator: Item<'BingMapNavigator'>;
  dataStoreReference: Item<'DataStoreReference'>;
  localDataStore: Item<'LocalDataStore'>;
} = {
  bingMapNavigator: {
    children: [],
    itemId: 'bingMapNavigator',
    parent: 'flexItem',
    props: {
      endLatAttribute: 'endLat',
      endLongAttribute: 'endLong',
      endMarkerIconAttribute: 'endMarkerIcon',
      endMarkerTitleAttribute: 'endMarkerTitle',
      markerSize: 40,
      startLatAttribute: 'startLat',
      startLongAttribute: 'startLong',
      startMarkerIcon: {
        iconName: 'archway',
        iconType: 'light',
      },
      startMarkerIconAttribute: 'startMarkerIcon',
      startMarkerIconColor: {
        type: 'text',
        value: 'red',
      },
      startMarkerTitleAttribute: 'startMarkerTitle',
    },
    type: 'BingMapNavigator',
  },
  dataStoreReference: {
    children: ['flexPanel'],
    itemId: 'dataStoreReference',
    parent: 'root',
    props: {
      alias: 'bingMapNavigatorHelpAlias',
    },
    type: 'DataStoreReference',
  },
  flexItem: {
    children: ['bingMapNavigator'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem'],
    itemId: 'flexPanel',
    parent: 'dataStoreReference',
    props: {},
    type: 'FlexPanel',
  },
  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'bingMapNavigatorHelpAlias',
      data: 'startLat,startLong,endLat,endLong,startMarkerIcon,endMarkerIcon,startMarkerTitle,endMarkerTitle\n42.589432,-94.61254,43.044561,-95.54321,charging-station,archway,Leland,Barron',
      dataSource: 'BingMapNavigatorHelp',
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'dataStoreReference'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'Blank Page',
      },
    },
    type: 'Page',
  },
};
